module.exports = __webpack_public_path__ + "static/media/success-btn.2bccabe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sku/success-btn.png
// module id = 806
// module chunks = 0